import { useEffect, useState } from "react";
import HeaderRoutesWithUnderlining from "../HeaderRoutes/HeaderRoutesWithUnderlining";

export const headerLinks = [
  {
    label: "Incidents",
    link: "/firehouse/incidents",
  },
  {
    label: "Overview",
    link: "/firehouse/incidents/overview",
  },
  {
    label: "Performance",
    link: "/firehouse/incidents/performance",
  },
  {
    label: "Map",
    link: "/firehouse/incidents/map",
  },
  {
    label: "Import History",
    link: "/firehouse/incidents/import-history",
  },
];

const IncidentsHeaderNav = () => {
  const [step, setStep] = useState();

  useEffect(() => {
    let i = headerLinks.findIndex((x) => {
      return x.link === window.location.pathname;
    });

    setStep(i);
  }, []);

  return (
    <div className="d-flex">
      {step !== undefined && <HeaderRoutesWithUnderlining step={step} steps={headerLinks} />}
    </div>
  );
};

export default IncidentsHeaderNav;
